import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

type ModalSize = 'large' | 'medium' | 'small';

const titlePadding = {
  large: `${anatomy['size-24']} ${anatomy['size-32']}`,
  medium: `${anatomy['size-20']} ${anatomy['size-28']}`,
  small: `${anatomy['size-16']} ${anatomy['size-24']}`,
};

const titleFontSize = {
  large: typography['fontSizeHeading-2'],
  medium: typography['fontSizeHeading-3'],
  small: typography['fontSizeHeading-4'],
};

const titleLineHeight = {
  large: typography['fontSizeHeading-2'],
  medium: typography['fontSizeHeading-3'],
  small: typography['lineHeightBody-4'],
};

const containerHeight = {
  large: '240px',
  medium: '200px',
  small: '160px',
};

const containerPadding = {
  large: `0 ${anatomy['size-32']}`,
  medium: `0 ${anatomy['size-28']}`,
  small: `0 ${anatomy['size-24']}`,
};

const footerGap = {
  large: anatomy['size-16'],
  medium: anatomy['size-12'],
  small: anatomy['size-8'],
};

const footerPadding = {
  large: `${anatomy['size-24']} ${anatomy['size-32']}`,
  medium: `${anatomy['size-20']} ${anatomy['size-28']}`,
  small: `${anatomy['size-16']} ${anatomy['size-24']}`,
};

export const styles = stylex.create({
  base: {
    visibility: 'hidden',
    opacity: 0,
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: -1,
    display: 'block',
    overflowX: 'hidden',
    overflowY: 'auto',
    outline: 0,
    pointerEvents: 'none',
    scrollbarWidth: 'none',
    borderRadius: anatomy['borderRadiusL'],
    background: colors['primaryBackground'],
    border: 'none',
    padding: 0,

    width: 'fit-content',
    height: 'fit-content',

    transform: 'translate(0, -50px)',
    transition: 'transform .3s ease-out, opacity .3s ease-out, visibility .3s ease-out, z-index .3s step-end',
  },
  active: {
    transform: 'none',
    visibility: 'visible',
    opacity: 1,
    pointerEvents: 'auto',
    zIndex: 1060,
    transition: 'opacity .3s ease-in-out, transform .3s ease-in-out, visibility 0s, z-index 0s',
  },
  title: (size) => ({
    color: colors['primaryText'],
    padding: titlePadding[size as ModalSize],
    fontFamily: fonts.din2014Regular,
    fontSize: titleFontSize[size as ModalSize],
    fontStyle: 'normal',
    fontWeight: typography['fontWeighDemi'],
    lineHeight: titleLineHeight[size as ModalSize],
  }),
  container: (size) => ({
    overflow: 'auto',
    height: containerHeight[size as ModalSize],
    borderRadius: anatomy['borderRadiusS'],
    padding: containerPadding[size as ModalSize],
    /* Скроллбар */
    '::-webkit-scrollbar': {
      width: anatomy['size-8'] /* Ширина скроллбара */,
    },
    /* Дорожка скроллбара */
    '::-webkit-scrollbar-track': {
      background: colors['ghostBackground'] /* Цвет дорожки */,
      margin: `${anatomy['size-8']} 0 ${anatomy['size-8']} 0`,
    },
    /* Ползунок скроллбара */
    '::-webkit-scrollbar-thumb': {
      background: colors['accentBackground'] /* Цвет ползунка */,
      borderRadius: anatomy['borderRadiusRound'] /* Радиус углов ползунка */,
    },
    /* Ползунок при наведении */
    '::-webkit-scrollbar-thumb:hover': {
      background: colors['accentBackground'] /* Цвет ползунка при наведении */,
    },
    scrollbarWidth: 'auto',
    scrollbarColor: `${colors['accentBackground']} ${colors['ghostBackground']}`,
  }),
  footer: (size) => ({
    display: 'flex',
    gap: footerGap[size as ModalSize],
    justifyContent: 'flex-end',
    padding: footerPadding[size as ModalSize],
  }),
});
